CustomTC.define('modules/config',['require'],function(module) {
    return {
        version: '3.0.3',
        domain: 'http://www.touchcast.com',
        cloudfrontVersion: '89',
        defaultAvatar: 'https://d1gf6lsaq3wby7.cloudfront.net/player/avatar.png',
        loadingGif: 'https://d1gf6lsaq3wby7.cloudfront.net/player/circular.gif',
        getFlashPlayerBtn: 'https://d1gf6lsaq3wby7.cloudfront.net/player/Get_Flash_Player.jpg',
        extensions: {
            flow: {
                url: 'exts/flow/flow.js'
            }
        }
        
    };
});
